import React, { ReactNode } from "react";
import styles from "../styles/voice-selector-modal-base.module.scss";
import { CategoriesDropdownProvider } from "@/components/pages/home/providers/categories-dropdown-provider";
import { GenderDropdownProvider } from "@/components/pages/home/providers/gender-dropdown-provider";

type VoiceSelectorModalProps = {
  children: ReactNode;
};

const VoiceSelectorModalBase = ({ children }: VoiceSelectorModalProps) => {
  return (
    <CategoriesDropdownProvider>
      <GenderDropdownProvider>
        <div className={styles.modal}>
          <div className={styles.content}>{children}</div>
        </div>
      </GenderDropdownProvider>
    </CategoriesDropdownProvider>
  );
};

export default VoiceSelectorModalBase;
